module.exports = __webpack_public_path__ + "img/steel.95342da3.svg";